import { FaDropbox } from 'react-icons/fa';
import { usePageContext } from '../node/context';
import { Language } from '../node/language';

function getMessages(lang: Language) {
  switch (lang) {
    case 'de':
      return {
        message:
          'Wir freuen uns Ihnen mitzuteilen, dass wir gemeinsam mit Dropbox, Inc. ein neues Kapitel aufschlagen werden. Dropbox erwirbt unsere IP-Technologie, um sie nativ in das Dropbox-Produkt einzubetten und damit Millionen von Geschäftskunden weltweit Ende-zu-Ende-Verschlüsselung mit Zero Knowledge bieten zu können. In unserem Blog erfahren Sie mehr!',
        buttonLabel: 'Erfahren Sie mehr',
      };
    default:
      return {
        message:
          'We are excited to share that we are set to begin a new chapter with Dropbox, Inc. Dropbox is acquiring our IP technology to embed natively into the Dropbox product, bringing end-to-end, zero-knowledge encryption to millions of business customers around the world. Check out our blog to find out more!',
        buttonLabel: 'Learn more',
      };
  }
}

export const Banner: React.FC = () => {
  const { lang } = usePageContext();

  const messages = getMessages(lang);

  return (
    <div className="bg-[#0061fe]">
      <div className="mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex flex-1 items-center">
            <span className="flex p-2">
              <FaDropbox className="h-6 w-6 text-white" aria-hidden="true" />
            </span>
            <p className="ml-3 font-medium text-white">
              <span>{messages.message}</span>
            </p>
          </div>
          <div className="order-3 mt-2 ml-1 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto">
            <a
              href="https://www.boxcryptor.com/blog/post/new-chapter-with-dropbox/"
              className="flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-[#0051D5] shadow-sm hover:bg-[#B7D2FF]"
            >
              {messages.buttonLabel}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
